module.exports = __webpack_public_path__ + "img/jiu5.2ee6d768.png";